import Backend from "../../../Backend";

export const getOrdersList = (params = {}) =>
  Backend.post("api/orders/list", {
    page: params.page || 0,
    pageSize: params.pageSize || 20,
    searchTerm: params.searchTerm || "",
    statusFilter: params.statusFilter || "ALL",
    sourceFilter: params.sourceFilter || "ALL",
    startDate: params.startDate || null,
    endDate: params.endDate || null,
  });

export const getOrder = (id) =>
  Backend.get(`api/orders/${id}`);

export const createOrder = (order) =>
  Backend.post("api/orders/create", order);

export const updateOrder = (id, order) =>
  Backend.put(`api/orders/${id}`, order);

export const updateOrderStatus = (id, status) =>
  Backend.put(`api/orders/${id}/status`, { status });

export const addTracking = (id, trackingNumber, carrier) =>
  Backend.put(`api/orders/${id}/tracking`, { trackingNumber, carrier });

export const deleteOrder = (id) =>
  Backend.delete(`api/orders/${id}`);

export const getOrderStats = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  const queryString = queryParams.toString();
  return Backend.get(`api/orders/stats${queryString ? `?${queryString}` : ""}`);
};

export const getOrdersNeedingFulfillment = () =>
  Backend.get("api/orders/needs-fulfillment");

// Order status options for dropdowns
export const ORDER_STATUS_OPTIONS = [
  { value: "ALL", label: "All Statuses" },
  { value: "PENDING", label: "Pending", color: "default" },
  { value: "PAID", label: "Paid", color: "blue" },
  { value: "PROCESSING", label: "Processing", color: "orange" },
  { value: "SHIPPED", label: "Shipped", color: "purple" },
  { value: "DELIVERED", label: "Delivered", color: "green" },
  { value: "CANCELLED", label: "Cancelled", color: "red" },
  { value: "REFUNDED", label: "Refunded", color: "volcano" },
];

// Order source options for dropdowns
export const ORDER_SOURCE_OPTIONS = [
  { value: "ALL", label: "All Sources" },
  { value: "WEBSITE", label: "Website", color: "blue" },
  { value: "WHOLESALE", label: "Wholesale", color: "green" },
  { value: "MANUAL", label: "Manual", color: "default" },
];

// Get status color
export const getStatusColor = (status) => {
  const option = ORDER_STATUS_OPTIONS.find((opt) => opt.value === status);
  return option?.color || "default";
};

// Get source color
export const getSourceColor = (source) => {
  const option = ORDER_SOURCE_OPTIONS.find((opt) => opt.value === source);
  return option?.color || "default";
};

// Format currency
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// Format date with time
export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};
